export default "__VITE_ASSET__cb52f3b9__"